import axios from 'axios'
import { Message,MessageBox } from 'element-ui'
import tokenUitl from '@/utils/token.js'
import router from '../../router'



let cancel ,promiseArr = {}

// create an axios instance
const service = axios.create({
  baseURL: process.env.BASE_API, // api的base_url
  timeout: 120000,// 请求超时时间120秒
  headers: {
    'Content-Type': 'application/json;charset=utf-8'
  }
})

// request拦截器
service.interceptors.request.use(config => {
  config.headers['PRO-token'] = tokenUitl.getToken();  //带token
  return config
}, error => {
    // Do something with request error
    console.log(error) // for debug
    Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    /**
     * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
     * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
     */
    const res = response.data;
    if (res &&res.status === 601) { // 自定义状态
      MessageBox.confirm(res.message, {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      })

    }else if(res &&res.status === 401){ //无权限
      MessageBox.confirm(res.message, {
        title:'提示',
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
    } else {
      /*Message({
        message: res.message,
        type: 'success',
        duration: 800
      })*/
      return response.data; //如果不返回response 就拿不到响应数据（切记）
    }

  },
  error => {
    //console.log('err' + error)// for debug
    if (error && error.response) {
      console.log("=====response error=====")
      console.log(error.response.data)
      console.log("=====response error=====")
      switch (error.response.data.status) {
        case 403:
          error.message = '拒绝访问'
          break;
        case 404:
          error.message = '请求错误,未找到该资源'
          break;
        case 405:
          error.message = '请求方法未允许,get或者post请求不正确'
          break;
        case 408:
          error.message = '请求超时'
          break;
        case 500:
          error.message = '服务器端出错'
          break;
        case 501:
          error.message = '网络未实现'
          break;
        case 502:
          error.message = '网络错误'
          break;
        case 503:
          error.message = '服务不可用'
          break;
        case 504:
          error.message = '网络超时'
          break;
        case 505:
          error.message = 'http版本不支持该请求'
          break;
        case 601:
          // 返回 601 清除token信息并跳转到登录页面
          MessageBox.confirm(error.response.data.message, {
            confirmButtonText: '重新登录',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            tokenUitl.removeToken();// 重新登录清空所有数据
            router.replace({
              path: '/'
            })
          })
          break;
        default:
          error.message = `连接错误${err.response.status}`
      }
    } else {
      error.message = "连接到服务器失败"
    }
    /*Message({
      message: error.message,
      type: 'error',
      duration: 8000
    })*/
    return Promise.reject(error)
  })

export default service



// WEBPACK FOOTER //
// ./src/api/request/request.js